module.exports = __webpack_public_path__ + "img/Resorts-World.5b609f3f.jpg";